module.exports = __webpack_public_path__ + "static/media/check-green.f5c84737.svg";